export default __webpack_public_path__ + "static/media/KYC.9ebd84b7.webp";